import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, credentials);
      
      if (response.data.status === 'success') {
        localStorage.setItem('admin_token', response.data.token);
        toast.success('Login successful!');
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.message || 'Invalid credentials');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(11, 44, 77, 0.95), rgba(11, 44, 77, 0.95)), url('https://images.unsplash.com/photo-1645301918921-6c744ab66e6f?w=1920')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-2xl p-8">
          {/* Logo */}
          <div className="text-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_bec05211-66fe-40f4-be9b-9c2beecb0c73/artifacts/bvs625is_Logogo.png" 
              alt="GoldenPort" 
              className="h-20 w-auto mx-auto mb-4"
            />
            <h1 className="text-3xl font-bold text-[#0B2C4D]">Admin Login</h1>
            <p className="text-gray-600 mt-2">Access your dashboard</p>
          </div>

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold text-[#0B2C4D] mb-2">
                Email Address
              </label>
              <Input
                type="email"
                name="email"
                value={credentials.email}
                onChange={handleChange}
                required
                placeholder="admin@goldenport.in"
                className="border-gray-300"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-[#0B2C4D] mb-2">
                Password
              </label>
              <Input
                type="password"
                name="password"
                value={credentials.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                className="border-gray-300"
              />
            </div>

            <Button 
              type="submit" 
              size="lg"
              disabled={isLoading}
              className="w-full bg-[#0B2C4D] hover:bg-[#0a2542] text-white border border-[#C9A24D] text-lg"
            >
              {isLoading ? (
                'Logging in...'
              ) : (
                <>
                  <LogIn className="w-5 h-5 mr-2" />
                  Login
                </>
              )}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <button 
              onClick={() => navigate('/')}
              className="text-sm text-[#0B2C4D] hover:text-[#C9A24D]"
            >
              ← Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
